import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { supportUser } from "../../rbac-consts";
import { default as SuperAdminSupportUserDetailsContainer } from "./superAdmin/details/SupportUserDetailsContainer";

const SupportUserDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <Can
      role={user.roles}
      perform={supportUser.SUPER_ADMIN}
      yes={() => (
        <SuperAdminSupportUserDetailsContainer match={match} />
      )}
    />
  );
};

export default SupportUserDetailsWrapper;
